import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { completeFacebookCallback } from "../lib/facebookAuth";

/** Lands here after the Cognito Hosted UI redirects back from Facebook. */
export default function CallbackPage() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode/dev double-invoke would otherwise re-use a spent code
    ran.current = true;
    completeFacebookCallback()
      .then(() => refresh())
      .then(() => navigate("/", { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : "Sign in failed."));
  }, [refresh, navigate]);

  return (
    <div className="card" style={{ maxWidth: 420, margin: "3rem auto" }}>
      {error ? (
        <>
          <h2>Sign in failed</h2>
          <p className="err">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })}>Back to sign in</button>
        </>
      ) : (
        <p className="muted">Signing you in…</p>
      )}
    </div>
  );
}
